import FieldFormTemplateModule from './fields.form.template';
import Grid from '../../view/grid';

import { hashify } from '../../utils/arrays';





export default FieldFormTemplateModule.extend( {

    template: 'module/refbooks/fields.form.types',

    url() {
        return this.model.id
            ? `fields/${this.model.id}/edit/bound-types`
            : `fields/new/bound-types`;
    },

    finalizeOpen(field) {
        // hack to allow reFilterRows work
        // TODO remove this hack
        this.model = field;
        this.reFilterGrid();
        this.model = undefined;
        return this.bind( field );
    },

    finalizeStart(field) {
        this.listenTo( field, 'change:cluster', () => {
            this.setState( { page: 1, } ), this.navigated();
            this.reFilterRows();
        } );
    },

    serialize() {
        const { sort, direction, search: searchString, } = this.state();
        const { typesFiltered, typesResulted } = this.options;

        return {
            searchString, sort, direction,
            hasDiff: () => this.hasDiff(),
            types: typesFiltered, rows: typesResulted,
            clusters: this.options.clusters,
        };
    },

    events: {

        'click .-sort'({currentTarget}) {
            const { sort, direction, } = currentTarget.dataset;
            const { types, typesSorted, } = this.options;

            return this.setState( { page: 1, sort, direction, } ),
                Grid.sort( this.state(), types, typesSorted, )
                    .then( () => this.reFilterGrid() )
                    // hack: to rerender grid caption with order direction
                    .then( () => this.render() )
                    .then( () => this.navigated() );
        },

        'click .-toggle-binding'({currentTarget}) {
            const { id } = currentTarget.dataset;
            const { typesFiltered } = this.options;

            const needAppend = currentTarget.checked;
            const oldTypes = this.model.get( 'types' );
            const newTypes = needAppend
                ? [...oldTypes, id]
                : oldTypes.filter( itemId => itemId != id );

            this.model.set( 'types', newTypes );

            const ids = hashify( newTypes );
            this.$( '.-toggle-all' )[0].checked = 
                this.getAvailableFilteredTypeIds( typesFiltered ).every( typeId => ids[typeId] );
        },

        'click .-toggle-all'({currentTarget}) {
            // contains ids of types that can be
            // checked/unchecked by current user
            const ids = this.getAvailableFilteredTypeIds( this.options.typesFiltered );

            const h = hashify( ids );
            const drained = this.model.get( 'types' )
                .filter( id => !h[id] )

            const value = currentTarget.checked;
            this.model.set( 'types', value
                ? [...drained, ...ids]
                : [...drained] );

            const values = hashify( this.model.get( 'types' ) );
            this.$( '.-toggle-binding' ).toArray()
                .forEach( el => el.checked = !!values[el.dataset.id] )
        }

    },

    reFilterGrid() {
        const { typesSorted, typesFiltered, typesResulted } = this.options;
        Grid.filter( this.state(), 
            this.model.get( 'cluster' ),
            typesSorted, typesFiltered, typesResulted );
    },
    
    [FieldFormTemplateModule.event( 'Paging:page')](page) {
        return this.setState( { page: +page, } ),
            this.reFilterGrid(),
            this.navigated();
    },

    [FieldFormTemplateModule.event( 'Search:search')](search) {
        return this.setState( { search, page: 1, } ), 
            this.reFilterGrid(),
            this.navigated();
    },

} );


// WEBPACK FOOTER //
// ./src/js/module/refbooks/fields.form.types.js